import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"

import { CustomBootstrapTable, CustomButton } from "components/Common"
import { convertDateFormat, indexCalculator } from "helpers/utilities"

import FilterForm from "./FilterForm"
import { exportExcelPatients } from "helpers/app-backend"

//i18n
import { CustomTooltipButton } from "components/Common/Button"
import { BadgeProfileType, ModuleIds } from "constant"
import BadgeItem from '../../../components/Common/BadgeItem'
import { withTranslation } from "react-i18next"


const RESOURCE = ModuleIds.Individual

const IndividualTable = ({
  onSelect,
  onSelectAll,
  individuals,
  onSearch,
  onSort,
  onRefresh,
  onPageChange,
  paging,
  onSizePerPageChange,
  onSubmitFilter,
  onEdit,
  onDelete,
  onClone,
  loading,
  t,
  updatedTime,
}) => {
  const [data, setData] = useState([])
  const [model, setModel] = useState({
    search: "",
    managementCompanyId: "",
    profileId: "",
  })

  const searchQuery = useSelector(state => state.individual.searchQuery)


  const onResetHandler = () => {
    const initModel = {
      search: "",
      managementCompanyId: "",
      profileId: "",
    }
    setModel(initModel)
  }

  useEffect(() => {
    setModel(searchQuery)
  }, [searchQuery])

  useEffect(() => {
    setData(individuals)
  }, [individuals])

  const onExportExcel = async () => {
    const res = await exportExcelPatients({ ...searchQuery, isPatient: false })
    const blob = new Blob([res])
    const fileName = "Danh_sach_ca_nhan.xlsx"
    saveAs(blob, fileName)
  }

  const columns = [
    {
      dataField: "id",
      text: "#",
      style: { width: 50 },
      formatter: (cellContent, user, index) => {
        return indexCalculator(paging.page, paging.size, index + 1)
      },
    },
    {
      dataField: "id",
      text: "#",
      hidden: true,
      formatter: (cellContent, user, index) => {
        return cellContent
      },
    },
    {
      dataField: "name",
      text: t("common:Name"),
      sort: true,
      formatter: (cellContent, user, index) => {
        return <Link to={`/Individual/${user.id}/view?tab=1`}>{user.name}</Link>
      },
    },
    {
      dataField: "managementCompanyId",
      text: t("Hospital/Clinic Mngt."),
      sort: true,
      formatter: (cellContent, user, index) => {
        return (
          <Link
            to={`/Company/${user.managementCompanyId}/view?tab=1`}
            target="_blank"
          >
            {user.managementCompanyName}
          </Link>
        )
      },
    },
    {
      dataField: "profileName",
      text: t("Profile"),
      sort: true,
      formatter: (cellContent, user, index) => {
        let badge = BadgeProfileType.filter(p => p.key.toLowerCase() === user?.profileName?.toLowerCase())
        if (badge.length > 0)
          badge = badge[0]
        else badge = {}
        const color = badge?.color;
        const textColor = badge?.textColor;
        const classname = badge?.classname;
        const key = badge?.key;
        return (
          <div className={`${classname} px-2 d-flex badge-gender`} style={{ backgroundColor: `${color}`, color: `${textColor}` }}>
            {user.profileName}
          </div>
        )

      },
    },
    // {
    //   dataField: "phoneNumber",
    //   text: t("common:PhoneNumber"),
    //   sort: true,
    // },
    {
      dataField: "address",
      text: t("common:Address"),
      sort: true,
    },
    {
      dataField: "createdDate",
      text: t("Created Date"),
      sort: true,
      formatter: (cellContent, user, index) =>
        convertDateFormat(cellContent, "HH:mm:ss DD-MM-YYYY"),
    },
    {
      dataField: "remark",
      text: t("common:Remark"),
      sort: true,
    },
    {
      dataField: "action",
      text: "",
      isDummyField: true,
      style: { width: 50 },
      formatter: (cellContent, individual, index) => {
        return (
          <CustomTooltipButton
            index={index}
            component={individual}
            onClone={onClone}
            onEdit={onEdit}
            onDelete={onDelete}
            isId
            t={t}
          />
        )
      },
    },
  ]

  return (
    <CustomBootstrapTable
      columns={columns}
      search
      data={data}
      paging={paging}
      onSelect={onSelect}
      onSelectAll={onSelectAll}
      onSearch={onSearch}
      onSort={onSort}
      onRefresh={onRefresh}
      filterForm={() => <FilterForm model={model} />}
      onReset={onResetHandler}
      onPageChange={onPageChange}
      onSizePerPageChange={onSizePerPageChange}
      onSubmitFilter={onSubmitFilter}
      searchText={model.search}
      loading={loading}
      updatedTime={updatedTime}
      resource={RESOURCE}
      isImportExportButton={true}
      importExportForm={() =>
        <div className="tooltip-custom">
          <CustomButton
            isEdit
            color="secondary"
            outline
            onClick={onExportExcel}
          >
            <i className={"fas fa-download"}></i>
          </CustomButton>
          <span className="tooltiptext-custom-button-icon-left">
            {t("common:Export All")}
          </span>
        </div>
      }
    />
  )
}

export default withTranslation(["partyPage", "common"])(IndividualTable)
